<!-- TODO: definire il testo -->
<app-toolkit-page-title title="Cookie policy"></app-toolkit-page-title>
<div class="row">
    <div class="col-sm-12">
        <p>
            Ai sensi del Regolamento Europeo 2016/679 (di seguito, anche “Regolamento”) e della normativa nazionale, Regione Lombardia (di seguito, anche “Titolare”), in qualità di Titolare del trattamento, riporta qui di seguito l’informativa estesa relativa ai cookie installati sul sito Censimento delle Opere di Difesa del Suolo (di seguito anche “Sito”) con lo scopo di illustrare i tipi, le modalità di utilizzo nonché di fornire indicazioni circa le azioni per rifiutare o eliminare i cookie presenti.
            
            <br>
            <br>
            <strong>
                
                1.	Cosa sono i cookie 
            </strong>

            <br>
            <br>
            I cookie sono piccoli file di testo che le applicazioni web inviano ai visitatori per diverse finalità. 
            Questi possono essere classificati a seconda di vari criteri:
            <br>
            -	Sito che li genera: cookie di prima parte, installati direttamente dal gestore del sito che si sta visitando, e cookie di terze parti, impostati da un sito web diverso da quello che l’utente sta visitando. 
            Finalità d’uso: cookie tecnici, volti a gestire gli aspetti tecnici necessari a erogare un servizio richiesto dall’utente, come ad esempio la navigazione di un sito internet, la gestione della sessione di un utente o il riconoscimento automatico della lingua preferita. Tra questo tipi di cookie sono utilizzati anche quelli di tipo analitico, anonimizzati e in forma aggregata, al fine di raccogliere informazioni sul numero degli utenti e su come questi visitano il sito internet e quindi elaborare statistiche generali sul servizio e sul suo utilizzo.
            Cookie profilazione di prima parte, utilizzati per analizzare le caratteristiche della navigazione dell’utente e creare profili in base al suo comportamento sul sito. 
            Cookie di terze parti, sono cookie utilizzati da servizi di “terze parti”, gestiti direttamente da terzi e di cui il Titolare del Sito non effettua alcun trattamento, che potrebbero usare anche cookie di profilazione. 
            <br>
            -	Durata: cookie permanenti, memorizzati nel dispositivo in modo permanente, cookie temporanei, aventi durata variabile e limitata, cookie di sessione, che scompaiano alla chiusura del browser o al momento del log-out.
            <br>
            <br>
            
            <strong>
                2.	Quali cookie vengono utilizzati in questo Sito e per quali finalità

            </strong>
            <br>
            <br>
            <strong>
                
                2.1	Cookie tecnici (non richiedono il consenso dell’interessato)
            </strong>
            <br>
            <br>
            Questo Sito utilizza cookie tecnici indispensabili per il corretto funzionamento del Sito, consentire una navigazione efficiente sullo stesso e garantire la sicurezza nella navigazione dei visitatori. Tali cookie sono strettamente necessari per le finalità di cui sopra e per consentire la fruizione dei contenuti e dei servizi richiesti dall’utente. Per l’installazione di tali cookie non è richiesto il preventivo consenso degli utenti.
            
            Inoltre, il Sito usa cookie analitici mediante il sistema di raccolta informazioni Web Analitycs Italia (WAI) al fine di analizzare statisticamente gli accessi o le visite al Sito stesso. Questi cookie possono essere assimilati ai cookie tecnici perché utilizzati direttamente e solo dal gestore del sito per raccogliere informazioni significative, in forma aggregata, che riguardano ad esempio, come gli utenti si interfacciano ai sistemi telematici, ovvero quali dispositivi, sistemi operativi o browser sono usati per l’accesso; la qualità e la fruibilità dei siti stessi, valutabili da semplici indicatori come la quantità di visite, la loro durata, la velocità di caricamento delle pagine o le ricerche effettuate dell’utente.
            
            Le informazioni raccolte da questo tipo di cookie sono in una forma tale da non consentire l'identificazione dell'utente in quanto WAI, basata su Matomo, utilizza di default l’anonimizzazione dell'indirizzo IP degli utenti. Tali Cookie non necessitano del preventivo consenso dell'Utente per essere installati ed utilizzati. Per ulteriori informazioni sul trattamento dei dati personali effettuato da Web Analytics Italia consultare l'informativa di WAI. 

            <br>
            <br>
            <strong>

                3.	Indicazioni sulla gestione dei cookie da parte dell’utente 
            </strong>
            <br>
            <br>
            Al primo accesso del Sito tutti i cookie di profilazione di prima parte e/o i cookie di terze parti, se previsti, sono bloccati, mentre sono attivi i soli cookie tecnici e funzionali descritti sopra. In applicazione del provvedimento del Garante “Linee guida cookie e altri strumenti di tracciamento" – 10 giugno 2021 [9677876] per l’acquisizione del consenso per l’uso dei cookies”, gli utenti del Sito possono dare il proprio consenso esplicito all’installazione dei cookie di profilazione sul proprio pc, tramite il banner che compare al primo accesso. In ogni momento gli utenti possono comunque visualizzare i cookie a cui hanno dato il consenso ed eventualmente modificare le proprie preferenze.  
            <br>
            <br>
            <strong>
                
                3.1	Disabilitare l’utilizzo dei cookie
            </strong>
            <br>
            <br>
            È possibile disabilitare tutti i cookie memorizzati sul proprio hard disk accedendo alla sezione apposita all’interno del browser. Di seguito sono riportati i link dove è possibile consultare le specifiche istruzioni per i principali browser in uso:
            <br>
            -	<a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-9">Edge</a>
            <br>
            -	<a href="https://support.google.com/chrome/answer/95647?hl=it">Firefox</a>
            <br>
            -	<a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie">Chrome</a>
            <br>
            -	<a href=" https://support.apple.com/it-it/guide/safari/sfri11471/mac">Safari</a>
            <br>
            <br>
            
            <strong>

                3.2	Attivare la modalità di navigazione anonima
            </strong>
            <br>
            <br>
            Mediante questa funzione disponibile ormai in tutti i browser, è possibile navigare in internet senza salvare alcuna informazione sui siti e sulle pagine visitate.
            Tuttavia, si precisa che i dati di navigazione, anche quando viene attivata tale funzionalità, sono registrati e conservati dai gestori dei siti web e dai provider di connettività.
            <br>
            <br>
            <strong>
                
                3.3	Eliminare direttamente i cookie
            </strong>
            <br>
            <br>
            Attualmente quasi tutti i browser consentono di eliminare i cookie installati.
            Per maggiori istruzioni, consultare la guida del proprio browser o visitare uno dei seguenti link:
            <br>
            -	<a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-9">Edge</a>
            <br>
            -	<a href="https://support.mozilla.org/it/kb/Eliminare%20i%20cookie">Firefox</a>
            <br>
            -	<a href="https://support.google.com/chrome/answer/95647?hl=it&ref_topic=3421433">Chrome</a>
            <br>
            -	<a href="http://support.apple.com/kb/HT1677">Safari</a>
            <br>
            <br>
            
            Tuttavia, ad ogni nuova sessione i cookie saranno reinstallati; in ragione di ciò si invita ad eseguire tale operazione periodicamente o utilizzare funzioni automatizzate per la cancellazione periodica.
            <br>
            <br>

            <strong>

                4.	Titolare del trattamento
            </strong>
            <br>
            <br>
            Il Titolare del trattamento è Regione Lombardia con sede in Piazza Città di Lombardia 1, 20124 Milano.
            
            <br>
            <br>
            <strong>

                5.	Responsabile della Protezione dei Dati (RPD)
            </strong>
            <br>
            <br>
            Il Responsabile della Protezione dei Dati (RPD) o Data Protection Officer (DPO) può essere contattato al seguente indirizzo di posta elettronica: <strong>rpd@regione.lombardia.it</strong>.
            
            <br>
            <br>
            <strong>

                6.	Diritti dell'interessato
            </strong>

            <br>
            <br>
            Ai sensi degli artt. 15-22 del Regolamento, è possibile far valere i seguenti diritti, ove applicabili:
            <br>
            •	Diritto di accesso ai dati, formulando opportuna richiesta delle seguenti informazioni: finalità e modalità del trattamento; categorie di dati personali in questione; destinatari o categorie di destinatari a cui i dati personali sono stati o saranno comunicati; periodo di conservazione dei dati; logica applicata al trattamento; estremi identificativi del titolare e dei responsabili; 
            <br>
            •	Diritto di rettifica, la richiesta dell’integrazione/modifica dei dati;
            <br>
            •	Diritto di cancellazione, la richiesta dell’eliminazione dei dati senza ingiustificato ritardo, fatti salvi tutti gli obblighi di conservazione imposti dalla legge;
            <br>
            •	Diritto alla portabilità dei dati, la richiesta di ricevere in formato strutturato, di uso comune e leggibile i dati personali.
            <br>
            <br>
            
            Le richieste per l’esercizio dei diritti dovranno essere inviate all’indirizzo di posta elettronica <strong>territorio_sistemiverdi@pec.regione.lombardia.it</strong> oppure a mezzo posta raccomandata all'indirizzo Regione Lombardia, Piazza Città di Lombardia 1, 20124 Milano, all'attenzione della Direzione Generale Territorio e Sistemi Verdi.
            
            È inoltre previsto il diritto di proporre reclamo all’Autorità di Controllo secondo l’art. 77 del Regolamento.
             
            <br><br>
            
        </p>
    </div>
</div>